





































































































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  Ref,
} from '@vue/composition-api';
import _ from 'lodash';

import useAxios from '@/useAxios';
import {
  getEmail,
  updateEmailSubject,
  updateEmail,
  deleteLanguage,
  deleteEmailImage,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonPanelWithExpandable from '@/components/CommonPanelWithExpandable.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

const Index = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonPanelWithExpandable,
    CommonDropzoneWithAxios,
  },
  setup() {
    const { axios } = useAxios();
    const loading: Ref<boolean> = ref(false);

    const email = reactive({
      image: '',
      subject: '',
      email: '',
      emailName: '',
      previewText: '',
      languages: [
        {
          key: '',
          date: '',
          time: '',
          topic: '',
          description: '',
          moreInfo: '',
          remarks: '',
          serverKey: '',
        },
      ],
    });

    function addLanguage() {
      email.languages.push({
        key: '',
        date: '',
        time: '',
        topic: '',
        description: '',
        moreInfo: '',
        remarks: '',
        serverKey: '',
      });
    }

    const callGetEmail = _.debounce(async () => {
      const { ALL, ...langs } = await getEmail();
      ALL.forEach((conf: any) => {
        if (conf.key === 'image') email.image = conf.value;
        if (conf.key === 'subject') email.subject = conf.value;
        if (conf.key === 'email') email.email = conf.value;
        if (conf.key === 'emailName') email.emailName = conf.value;
        if (conf.key === 'previewText') email.previewText = conf.value;
      });
      email.languages = Object.entries(langs).map(([key, value]: any[]) => {
        let date = '';
        let time = '';
        let topic = '';
        let description = '';
        let moreInfo = '';
        let remarks = '';
        value.forEach((conf: any) => {
          if (conf.key === 'date') date = conf.value;
          if (conf.key === 'time') time = conf.value;
          if (conf.key === 'topic') topic = conf.value;
          if (conf.key === 'description') description = conf.value;
          if (conf.key === 'moreInfo') moreInfo = conf.value;
          if (conf.key === 'remarks') remarks = conf.value;
        });
        return {
          key,
          date,
          time,
          topic,
          description,
          moreInfo,
          remarks,
          serverKey: key,
        };
      });
    }, 500);

    onMounted(async () => {
      await callGetEmail();
    });

    async function uploadDone() {
      await callGetEmail();
    }

    const formattedPayload = computed(() => {
      const payload: any = {};
      email.languages.forEach((language: any) => {
        payload[language.key] = [
          { key: 'date', value: language.date },
          { key: 'time', value: language.time },
          { key: 'topic', value: language.topic },
          { key: 'description', value: language.description },
          { key: 'moreInfo', value: language.moreInfo },
          { key: 'remarks', value: language.remarks },
        ];
      });
      return payload;
    });

    const saveSuccessModal = ref(null);
    async function saveLanguage(languageKey: string) {
      if (languageKey === '') return false;
      const response = await updateEmail({ [languageKey]: formattedPayload.value[languageKey] });
      if (response.status !== 1) {
        const oldKey = email.languages.findIndex((language: any) => language.key === languageKey);
        if (email.languages[oldKey].serverKey !== languageKey) await deleteLanguage(email.languages[oldKey].serverKey);
        (saveSuccessModal.value as any).compose({ action: 'บันทึก', entity: 'ชุดข้อความ' });
        await callGetEmail();
      }
      return true;
    }

    // Use to delete Image
    const deleteImageModal = ref(null);
    async function deleteImageAction() {
      await deleteEmailImage();
      await callGetEmail();
      email.image = '';
    }
    function openDeleteImageModal() { (deleteImageModal.value as any).compose({ action: 'ลบ', entity: 'รูปภาพ' }); }

    // Use to delete Language
    const deleteLanguageModal = ref(null);
    async function deleteLanguageAction(ctx: { index: number; key: string }) {
      if (ctx.key === '') {
        email.languages.splice(ctx.index, 1);
      } else {
        await deleteLanguage(ctx.key);
        await callGetEmail();
      }
    }
    function openDeleteLanguageModal(key: any, index: number) {
      (deleteLanguageModal.value as any).compose({
        index, key, action: 'ลบ', entity: 'ภาษา',
      });
    }

    // Use to save email Subject
    async function saveEmailHeader() {
      const payload: { key: string; value: string }[] = [];
      if (email.subject !== '') payload.push({ key: 'subject', value: email.subject });
      if (email.email !== '') payload.push({ key: 'email', value: email.email });
      if (email.emailName !== '') payload.push({ key: 'emailName', value: email.emailName });
      if (email.previewText !== '') payload.push({ key: 'previewText', value: email.previewText });
      if (email.image !== '') payload.push({ key: 'image', value: email.image });
      const response = await updateEmail({ ALL: payload });
      if (response.status !== 1) {
        (saveSuccessModal.value as any).compose({ action: 'บันทึก', entity: 'หัวข้อ' });
        await callGetEmail();
      }
      return true;
    }

    return {
      loading,
      addLanguage,
      email,

      saveSuccessModal,
      saveEmailHeader,
      saveLanguage,

      deleteLanguageModal,
      deleteLanguageAction,
      openDeleteLanguageModal,

      axios,
      uploadDone,
      deleteImageModal,
      deleteImageAction,
      openDeleteImageModal,
    };
  },
});

export default Index;
